/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Building_Access_Suspended_User_MessageInputs */



/**
* | output |
* | --- |
* | "Contact the building administrator for more information." |
*
* @param {Building_Access_Suspended_User_MessageInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const building_access_suspended_user_message = /** @type {((inputs?: Building_Access_Suspended_User_MessageInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Building_Access_Suspended_User_MessageInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Contact the building administrator for more information.")
	return /** @type {LocalizedString} */ ("Rapprochez-vous de l’administrateur du bâtiment pour en savoir plus.")
});